import React, { useState, useEffect } from "react";
import WidgetCard from "./WidgetCard";
import { Col, Row, Select } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { COLORS } from "@/ts/constants";
import { ICtrTrendOverTimeProps } from "@/ts/common-types";

const { Option } = Select;

interface IProps extends ICtrTrendOverTimeProps {
    selectedSku: string;
}

const MyVsCompetitorSkuSOVWidget: React.FC<IProps> = ({ widgetData, selectedSku, additionalTitleComponent, filterPillsComponent }) => {
    const allSkus = widgetData?.categories || [];
    const selectableSkus = allSkus.filter((sku) => sku !== selectedSku);
    const defaultSkus = selectableSkus.slice(0, 2);
    const [selectedSkus, setSelectedSkus] = useState<string[]>(defaultSkus);

    useEffect(() => {
        setSelectedSkus((prev) => prev.slice(0, 2));
    }, [selectedSku]);

    const handleSkuChange = (selected: string[]) => {
        setSelectedSkus(selected.slice(0, 2));
    };

    const xAxisCategories = ["My SKU", ...selectedSkus];

    const filteredSeries = widgetData?.series.map((seriesItem) => ({
        ...seriesItem,
        data: seriesItem.data.filter((_, index) => {
            const sku = allSkus[index];
            return sku === selectedSku || selectedSkus.includes(sku);
        }),
    }));

    const chartOptions = {
        chart: { type: "column" },
        colors: COLORS,
        credits: {
            enabled: false,
        },
        title: { text: "" },
        xAxis: { categories: xAxisCategories },
        yAxis: {
            title: { text: "SOV %" },
            labels: { formatter: function (this: any) { return this.value + "%"; } },
        },
        legend: { align: "center", verticalAlign: "bottom", layout: "horizontal" },
        series: filteredSeries,
    };

    return (
        <WidgetCard className="my-4">
            <Row className="mb-3" justify="space-between" align="middle">
                <Col span={17}>
                    <h5>Share of Voice (SOV): My SKU vs Competitor SKUs</h5>
                </Col>
                <Col span={5}>
                    <Select
                        mode="multiple"
                        value={selectedSkus}
                        onChange={handleSkuChange}
                        className="w-100"
                        maxTagCount={2}
                        placeholder="Select SKUs to compare"
                    >
                        {selectableSkus.map((sku: string) => (
                            <Option
                                key={sku}
                                value={sku}
                                disabled={
                                    selectedSkus.length >= 2 &&
                                    !selectedSkus.includes(sku)
                                }
                            >
                                {sku}
                            </Option>
                        ))}
                    </Select>
                </Col>
                {additionalTitleComponent && (
                    <Col span={1}>{additionalTitleComponent()}</Col>
                )}
            </Row>
            {filterPillsComponent && (
                <Row>
                    <Col span={24}>
                        {filterPillsComponent()}
                    </Col>
                </Row>
            )}
            <Row className="d-flex w-100">
                <Col span={24}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions}
                    />
                </Col>
            </Row>
        </WidgetCard>
    );
};

export default MyVsCompetitorSkuSOVWidget;
